import './../css/head.css';
import axios from 'axios';
export default {
  props: {
    menuInfo: {
      type: Object
    },
    page: {
      type: String,
      default: '首页'
    },
    searchText: String,
    isNeedLogin: {
      type: Boolean,
      default: false
    },
    menuCode: String || Number
  },

  created() {
    this.getObjectStatus();
    this.getUserInfo();
    this.getNavList();
    this.getFilterList();
  },

  mounted() {
    this.getBaseSet();
    this.addPv();
    this.titleFixed = false; // 从URL参数中获取major_type

    const params = new URLSearchParams(window.location.search);
    const majorType = params.get('major_type');
    console.log('当前选中的标签值:', majorType); // 遍历所有标签，找到匹配的标签并设置选中状态

    this.setSelectedTagByType(majorType); // 滚动监听保留

    window.addEventListener('scroll', this.handleScroll, true);
  },

  unmounted() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  data() {
    return {
      selectedTags: {},
      isFocus: false,
      // 是否获得焦点
      keyword: this.searchText,
      showBubbles: false,
      hoveredMenu: '',
      // 当前悬停的菜单
      bubblesHovered: '',
      headInfo: {},
      userInfo: null,
      moocMenu: {},
      spocMenu: {},
      teacherMenu: {},
      newMenu: {},
      logoUrl: '',
      navList: [],
      headerBg: '',
      footer: '',
      url: location.href.substring(location.href.indexOf('?') + 1),
      centerList: [],
      headList: [],
      onlineTeache: null,
      currentPage: '首页',
      userRole: 0,
      zhsRole: 0,
      linkNav: [],
      // 导航中的外部链接
      teacherMenuId: '',
      showLogin: false,
      backUrl: `//${process.env.VUE_APP_HOST}/admin/`,
      titleFixed: false,
      classifyList: []
    };
  },

  computed: {
    config() {
      return this.$config;
    },

    CurrentUrl() {
      return this.page || window.location.href;
    },

    noTicketUrl() {
      return this.$utils.removeUrlParam(['ticket']);
    },

    showNavList() {
      return this.navList.slice(0, 7);
    },

    hideNavList() {
      return this.navList.slice(7);
    }

  },
  methods: {
    onBubbleClick(menuID, type, menu_name, ids) {
      console.log(`点击了${menu_name}${type}标签`);

      if (menu_name == '特色专业') {
        if (type == '微电子科学与工程') {
          window.open('http://t.zhihuishu.com/R47J0jXy');
        } else if (type == '机械电子工程') {
          window.open('http://t.zhihuishu.com/Oz1oNL2Y');
        } else if (type == '物流管理') {
          window.open('http://t.zhihuishu.com/63Zw5V9V');
        } else {
          // 跳转到目标URL
          window.location.href = `/major.html?menuId=${menuID}&major_info=专业详情&major_type=${type}`;
        }
      } else if (menu_name == '荣誉课程') {
        window.location.href = `/courseList.html?type=1&menuId=${menuID}&major_type=${type}&ids=${ids}&name=${menu_name}`;
      } else if (menu_name == '特色课程') {
        window.location.href = `/courseList.html?type=1&menuId=${menuID}&major_type=${type}&ids=${ids}&name=${menu_name}`;
      }
    },

    handleMouseEnter(menuName) {
      this.hoveredMenu = menuName;
    },

    // 根据标签值找到对应的菜单和标签并设置选中
    setSelectedTagByType(targetType) {
      if (!targetType) return; // 遍历所有可能的菜单

      const allMenus = ['特色专业', '荣誉课程', '特色课程', '更多'];
      allMenus.forEach(menuName => {
        // 获取菜单下的所有标签
        const tags = this.getBubbleTags(menuName); // 查找是否有标签名称匹配targetType

        const matchedTag = tags.find(tag => tag.name === targetType);

        if (matchedTag) {
          this.selectedTags[menuName] = targetType;
          console.log(`找到匹配的标签: 菜单=${menuName}, 标签=${targetType}`);
        }
      });
    },

    // 其他方法保持不变...
    isTagSelected(menuName, tagName) {
      return this.selectedTags[menuName] === tagName;
    },

    async getFilterList() {
      let params = {
        course_type: this.courseType,
        classify_id: this.classifyId || "",
        menu_id: this.menuId // menu_id: this.courseType == 1 ? this.moocMenuId : this.spocMenuId

      };
      const res = await this.$http.getFilterList(params);
      console.log("筛选列表", res);
      this.classifyList = res.classify_list;
      this.categoryList = res.organ_tree.children;
      let organNum = res.organ_tree.courseNum;
    },

    // 处理鼠标离开事件
    handleMouseLeave(menuName) {
      // 只有当气泡标签没有被悬停时才重置
      if (this.bubblesHovered !== menuName) {
        this.hoveredMenu = '';
      }
    },

    // 判断菜单项是否有气泡标签
    hasBubbles(menuName) {
      return ['特色专业', '荣誉课程', '特色课程', '更多'].includes(menuName);
    },

    // 获取菜单项对应的气泡标签
    getBubbleTags(menuName) {
      const tagsMap = {
        '特色专业': [{
          name: '国一流专业',
          ids: ''
        }, {
          name: '省一流专业',
          ids: ''
        }, {
          name: '微专业',
          ids: ''
        }, {
          name: '微电子科学与工程',
          ids: ''
        }, {
          name: '机械电子工程',
          ids: ''
        }, {
          name: '物流管理',
          ids: ''
        }],
        '荣誉课程': [{
          name: '一流课程',
          ids: '1931540096075567104'
        }, {
          name: '高阶课程',
          ids: '1931540167357763584'
        }, {
          name: '课程思政示范课程',
          ids: '1931559837196488704'
        }],
        '特色课程': [{
          name: '校企共建课程',
          ids: ''
        }],
        '更多': [...this.hideNavList]
      };
      return tagsMap[menuName] || [];
    },

    getClassifyTags() {
      return (this.classifyList || []).map(item => ({
        name: item.name,
        ids: item.id // 存储需要传递的额外ID

      }));
    },

    // 关键字搜索
    handleSearch() {
      if (this.keyword) {
        window.location.href = `/search.html?keyword=${this.keyword}`;
      }
    },

    zhsLogin() {
      const host = window.location.protocol + '//' + window.location.host;
      const url = host + '/index.html';
      window.location.href = `${host}/hike-boot/AuthSys/getAuthorize?redirectUri=${url}&failRedirectUri=${url}&source=${this.config.schoolId}`;
    },

    // 获取用户信息
    async getUserInfo() {
      let token = this.$utils.getCookie('X-Access-Token');
      let ticket = this.$utils.getUrlParams('ticket');

      if (token) {
        const userInfo = await this.$http.getUserInfo();
        this.userInfo = userInfo;
        console.log('用户信息', userInfo); // this.userInfo.uuid = "VJ77z84b";

        if (this.userInfo.uuid) {
          this.getUserZhsRole();
          this.getUserIdentity();
        }

        this.$emit('getUserInfo', userInfo);
        return;
      } // 是否需要登录


      if (this.isNeedLogin) {
        // window.location.href = '/login.html'
        window.location.href = this.$zhsLoginUrl;
      }

      return null;
    },

    // 获取用户智慧树角色
    async getUserIdentity() {
      let params = {
        schoolId: this.config.schoolId,
        uuid: this.userInfo.uuid
      };
      const res = await this.$http.getUserIdentity(params); // 	0:未认证 1:管理者 2:老师 3:学生

      console.log('智慧树角色', res);
      this.userRole = res;
      this.$emit('userRole', this.userRole);
    },

    // 获取用户智慧树权限
    async getUserZhsRole() {
      const res = await this.$http.getUserZhsIdentity({
        uuid: this.userInfo.uuid
      }); //  role = 2 有数据中心权限，role=0 虽然有myuni权限，但是没有数据中心权限 role = 1 数据中心权限、教学指挥中心权限,

      console.log('智慧树权限', res);
      this.zhsRole = res.role;
    },

    async logout() {
      try {
        let token = this.$utils.getCookie('X-Access-Token');

        if (token) {
          let res = await this.$http.logout();
          this.$utils.delCookie('X-Access-Token');
          this.zhsLogout();
        } else {
          // window.location.href = `/login.html`
          window.location.href = `/index.html`;
        }
      } catch (e) {
        console.log(e);
      }
    },

    // 智慧树退出登录
    zhsLogout() {
      // service 智慧树退出登录
      axios.defaults.withCredentials = true;
      axios.post('//oauth.zhihuishu.com/logout').then(res => {
        console.log(res);
      }).catch(error => {
        console.log(error);
      }); // window.location.href = `//passport.zhihuishu.com/logout?service=https://${process.env.VUE_APP_HOST}/login.html`

      window.location.href = `//passport.zhihuishu.com/logout?service=https://${process.env.VUE_APP_HOST}/index.html`;
    },

    async getNavList() {
      const res = await this.$http.getNavList(); // 导航

      const res2 = await this.$http.getConfigList(); // 登录权限

      console.log('登录权限', res2);
      const res3 = await this.$http.getObjectOpen(); // 项目已开启功能

      this.centerList = res3.filter(item => item.type == '2');
      sessionStorage.setItem('authInfo', JSON.stringify(res2)); // 详情页判断登录用
      // 账号设置页用到

      this.teacherMenuId = res.find(item => item.menu_code == '10501') ? res.find(item => item.menu_code == '10501').id : '';
      this.showLogin = res3.some(item => item.code == '10000'); // 是否有登录按钮

      this.linkNav = res.filter(item => item.menu_type == 4); // 菜单需登录

      let list = JSON.parse(JSON.stringify(res));
      const menu = res2.filter(i => i.auth_type == 5);
      let newArr = [];
      menu.forEach(item => newArr.push(item.code));
      let dataList = list;

      if (!this.userInfo) {
        dataList = res.filter(item => !newArr.includes(item.menu_code));
      }

      const i = res2.findIndex(i => i.code == this.menuCode);
      const {
        auth_type
      } = res2[i] || {};
      this.$emit('authType', auth_type);
      const urlList = {
        10301: '/index.html',
        0: '/major.html',
        10401: '/courseList.html?type=1',
        10402: '/courseList.html?type=2',
        10501: '/teacherList.html',
        10601: '/live.html',
        10701: '/notice.html',
        30200: '/teachingCenterList.html'
      };

      if (auth_type === 3 && !this.userInfo || auth_type === 5 && !this.userInfo) {
        // window.location.href = `/login.html?service=${location.href}`
        window.location.href = this.$zhsLoginUrl;
      } // 点击导航跳转到对应taget_url,并传参


      const data = dataList.map(item => ({ ...item,
        target_url: item.target_url && item.target_url.trim().length > 0 ? item.target_url : item.menu_code == 10401 || item.menu_code == 10402 ? `${urlList[item.menu_code]}&menuId=${item.id}&name=${item.menu_name}` : `${urlList[item.menu_code || 0]}?menuId=${item.id}&name=${item.menu_name}`
      }));
      this.navList = data; // 当前页面 导航高亮

      const currentPageIndex = (this.navList || []).findIndex(item => item.id === this.$utils.getUrlParams('menuId')) || 0;

      if (this.navList[currentPageIndex]) {
        this.currentPage = this.navList[currentPageIndex].menu_name;
        this.$emit('update:menuInfo', this.navList[currentPageIndex]);
      } // 头部指挥中心等按钮展示规则


      if (this.linkNav.length) {
        let arr = [];
        this.linkNav.forEach(item => arr.push(item.menu_code));
        this.headList = this.centerList.filter(item => !arr.includes(item.code) && item.code !== '16001'); // console.log("this.headList", this.headList);

        this.onlineTeache = this.centerList.find(item => item.code == '16001');
      }
    },

    // 基础配置信息
    async getBaseSet() {
      const res = await this.$http.getBaseSet();
      this.logoUrl = res.home_logo_url || require('../../assets/images/head_logo.png');
      this.headerBg = res.back_logo_url; // 浏览器图标

      var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'shortcut icon';
      link.href = res.icon_url;
      document.getElementsByTagName('head')[0].appendChild(link);
    },

    // 访问量
    async addPv() {
      let params = {};
      const res = await this.$http.addPv(params, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      });
    },

    // 项目状态
    async getObjectStatus() {
      const res = await this.$http.getObjectStatus();

      if (res.status == '0') {
        window.location.href = '/stop.html';
      }
    },

    goAccountSet() {
      window.location.href = `/setting.html?id=${this.teacherMenuId}`;
    },

    // 返回顶部
    backTop() {
      let timer = setInterval(() => {
        let ispeed = Math.floor(-this.scrollTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop = this.scrollTop + ispeed;

        if (this.scrollTop === 0) {
          clearInterval(timer);
        }
      }, 20);
    },

    handleScroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      this.scrollTop = scrollTop;
      let offsetTop = this.$refs.pride_tab_fixed.getBoundingClientRect().top;
      this.titleFixed = offsetTop < 0;
    }

  }
};